import { render } from "./Terms.m.vue?vue&type=template&id=326c2848&scoped=true"
import script from "./Terms.m.vue?vue&type=script&lang=js"
export * from "./Terms.m.vue?vue&type=script&lang=js"

import "./Terms.m.vue?vue&type=style&index=0&id=326c2848&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326c2848"]])

export default __exports__